import { UpdateAdminConfigurationRequestDTO } from "../../../shared/oversight-core/dtos/request-dtos/update-admin-configuration-request-dto";
import { ViewAdminConfigurationResponseDTO } from "../../../shared/oversight-core/dtos/response-dtos/view-admin-configuration-response-dto";
import { ViewUserConfigurationResponseDTO } from "../../../shared/oversight-core/dtos/response-dtos/view-user-configuration-response-dto";
import { EConfigurationType } from "../../../shared/oversight-core/enums/configuration-type";
import { transformErrorResponse } from "../../../shared/oversight-core/utils/transformErrorResponse";
import { rootApi } from "../apiManager";

export const settingsAPI = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    requestUserDataRemoval: builder.mutation<
      void,
      {
        password: string;
      }
    >({
      transformErrorResponse,
      query({ password }) {
        return {
          url: `user/remove-user-date`,
          method: "DELETE",
          body: { password },
        };
      },
      invalidatesTags: ["Schedule"],
    }),
    viewAdminConfiguration: builder.query<
      ViewAdminConfigurationResponseDTO,
      { configurationType: EConfigurationType }
    >({
      query: ({ configurationType }) => ({
        url: `admin/configuration/view`,
        method: "GET",
        params: { configurationType },
      }),
      transformErrorResponse,
    }),
    viewUserConfigurationForAdmin: builder.query<
      ViewUserConfigurationResponseDTO,
      { userId: string; configurationType: EConfigurationType }
    >({
      query: ({ userId, configurationType }) => ({
        url: `admin/user-configuration/${userId}/view`,
        method: "GET",
        params: { configurationType },
      }),
      transformErrorResponse,
    }),
    updateAdminConfiguration: builder.mutation<
      ViewAdminConfigurationResponseDTO,
      UpdateAdminConfigurationRequestDTO
    >({
      query(data) {
        return {
          url: "admin/configuration/update",
          method: "PUT",
          body: data,
        };
      },
      transformErrorResponse,
    }),
  }),
  overrideExisting: false,
});

export const {
  useRequestUserDataRemovalMutation,
  useLazyViewAdminConfigurationQuery,
  useLazyViewUserConfigurationForAdminQuery,
  useUpdateAdminConfigurationMutation,
} = settingsAPI;
